import { Component, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { RoutingService } from 'src/app/service/routing.service';
import { UserStateService } from 'src/app/shared/services/user-state.service';
import { BreakpointService } from 'src/app/shared/services/breakpoints.service';

@Component({
  selector: 'app-news-chartmap',
  templateUrl: './news-chartmap.component.html',
  styleUrls: ['./news-chartmap.component.scss'],
})
export class NewsChartmapComponent {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  params: any;
  screenSize$ = this.breakpointService.screenSize$;
  constructor(
    private route: ActivatedRoute,
    public routing: RoutingService,
    public userState: UserStateService,
    private breakpointService: BreakpointService,
    private destroyRef: DestroyRef,
  ) {
    this.route.queryParams
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        this.params = params;
      });
  }
}
